<template>
  <div class="timeInlineBlockList">
    <nuxt-link class="item" v-for="item in list" :key="item.id" :to="`${toPath}${item.id}?from=${Route.path}`">
      <div class="time" v-if="item.createTime">
        <div class="date">{{ dayjs(item.createTime).format("MM-DD") }}</div>
        <div class="year">{{ dayjs(item.createTime).format("YYYY") }}</div>
      </div>
      <div class="content">
        <div class="title">{{item.contentTitle}}</div>
        <div class="intro">{{item.content}}</div>
      </div>
    </nuxt-link>
  </div>
</template>

<script setup>
import dayjs from "dayjs";

const Route = useRoute();

const props = defineProps({
  list: {
    required: true,
    type: Array
  },
  toPath: {
    required: true,
    type: String
  }
})
</script>

<style scoped lang="scss">
.timeInlineBlockList {
  margin: 60px 0;
  > .item {
    //padding: 40px 0;
    padding-bottom: 12px;
    margin-bottom: 32px;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    text-decoration: none;
    //align-items: center;
    .time {
      flex-shrink: 0;
      border: 2px solid var(--main-blue-color);
      padding: 12px 26px 8px;
      text-align: center;
      margin-right: 50px;
      .date {
        font-size: 24px;
        color: var(--main-blue-color);;
      }
      .year {
        font-size: 17px;
        line-height: 1.5;
        color: #4D9DFD;
        margin-top: 6px;
        border-top: 1px solid #4D9DFD;
        padding-top: 12px;
      }
    }
    .content {
      .title {
        font-size: 18px;
        line-height: 26px;
        color: var(--title-text-color);
        padding-top: 10px;
        padding-left: 5px;
      }
      .intro {
        //color: var(--secondary-text-color);
        color: #333;
        font-size: 16px;
        width: 1100px;
        overflow: hidden;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        margin-top: 15px;
        line-height: 24px;
      }
    }
    &:hover {
      border-color: var(--main-blue-color);
      .content {
        .title {
          color: var(--main-blue-color);
        }
      }
    }
  }
}
</style>